import { api } from 'trpc/react';

export const useCartCount = () => {
    const { data } = api.cart.getCount.useQuery(undefined, {
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        staleTime: 0,
    });

    const count = data?.count ?? 0;
    const display = count > 99 ? '99+' : String(count);
    return { count, display };
};
